import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import "./common/Assets/styles/color.scss";
import "./common/Assets/styles/fonts.scss";
import "./common/Assets/styles/responsive.scss";
import "./common/Assets/styles/Style.scss";
import "./common/Assets/styles/width.scss";
import "./common/Assets/styles/height.scss";
import "./common/Assets/styles/custome.scss";

import Login from "./Screen/Login/Login";
// import LoginPages from "./Screen/Login/LoginPages";
// import LoginVerification from "./Screen/Login/LoginVerification";
// import LoginResetPassword from "./Screen/Login/LoginResetPassword";
import Layout from "./common/Layout/Layout";
import NotFound from "./Components/NotFound";
import HttpClient from "./Services/HttpClient";
import PrivateRoutes from "./common/Layout/privateRoutes";
import ForgotPassword from "./Screen/Login/ForgotPassword";
import ResetPassword from "./Screen/Login/ResetPassword";
import Dashboard from '../src/Screen/Dashboard'
import Admin from "./Screen/AdminScreen/Admin";
import AddAdmin from "./Screen/AdminScreen/AddAdmin";
import Roles from "./Screen/RolesScreen/Roles";
import AddRoles from "./Screen/RolesScreen/AddRoles";
import Users from "./Screen/UsersScreen/Users";
import ViewUsers from "./Screen/UsersScreen/ViewUsers";
import Vehicle from "./Screen/VehicleScreen/Vehicle";
import AddVehicle from "./Screen/VehicleScreen/AddVehicle";
import Transport from "./Screen/TransportManagement/Transport";
import AddTransport from "./Screen/TransportManagement/AddTransport";
import Transaction from "./Screen/TransactionManagement/Transaction";
import TransactionView from "./Screen/TransactionManagement/TransactionView";
import UserTransactions from "./Screen/TransactionManagement/UserTransactions";
import PushNotification from "./Screen/PushNotification/PushNotification";
import Faq from "./Screen/FAQ/Faq";
// import Help from "./Screen/HelpSupport/Help";
// import Contact from "./Screen/Contact/Contact";
// import HelpSupport from "./Screen/HelpSupport/HelpSupport";
// import Help from "./Screen/HelpSupport/Help"
import PushNotificationAdd from "./Screen/PushNotification/PushNotificationAdd";
import FAQEdit from "./Screen/FAQ/FAQEdit";
import Contact from "./Screen/Contact/Contact";
import AddContact from "./Screen/Contact/AddContact";
import Helpview from "./Screen/HelpSupport/Helpview";
import TransportView from "./Screen/TransportManagement/TransportView";
import HelpSupport from "./Screen/HelpSupport/HelpSupport";
import VehicleTransport from "./Screen/TransportManagement/VehicleTransport";
import AddVehicleTransport from "./Screen/TransportManagement/AddVehicleTransport";
import VehiclesTripHistory from "./Screen/TransportManagement/VehiclesTripHistory";
import TransportDrivers from "./Screen/TransportManagement/TransportDrivers";
import AddDriverTransport from "./Screen/TransportManagement/AddDriverTransport";
import DriverTripHistory from "./Screen/TransportManagement/DriverTripHistory";
import BookingManagement from "./Screen/BookingManagement/BookingManagement";
import BookingRequest from "./Screen/BookingManagement/BookingRequest";
import BookingAssign from "./Screen/BookingManagement/BookingAssign";
import TransportBookings from "./Screen/TransportManagement/TransportBookings";
const RctRoutes = () => {
  const token = localStorage.getItem("token");
  if (token) {
    HttpClient.defaults.headers.common["Authorization"] =
      `Bearer ${token}` || "";
  }
  return (
    <div>
      <Routes>
        <Route
          path="/"
          element={token ? <Navigate to="/general-user" /> : <Login />}
        />
        <Route path="/login" element={<Login />} />
        <Route path="/forget-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route element={<PrivateRoutes />}>
          <Route element={<Layout />}>
            <Route path="/general-user" element={<Dashboard />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/add-admin" element={<AddAdmin />} />
            <Route path="/roles" element={<Roles />} />
            <Route path="/add-roles" element={<AddRoles />} />

            <Route path="/users" element={<Users />} />
            <Route
              path="/view-users"
              element={<ViewUsers />}
            />
            <Route path="/vehicle" element={<Vehicle />} />
            <Route path="/add-vehicle" element={<AddVehicle />} />
            <Route
              path="/transport"
              element={<Transport />}
            />

            <Route path="/add-transport" element={<AddTransport />} />
            <Route path="/view-transport" element={<TransportView />} />
            <Route path="/vehicle-transport" element={<VehicleTransport />} />
            <Route path="/addvehicle-transport" element={<AddVehicleTransport />} />
            <Route path="/vehicle-triphistory" element={<VehiclesTripHistory />} />
            <Route path="/drivers-transport" element={<TransportDrivers />} />
            <Route path="/transport-bookings" element={<TransportBookings />} />
            <Route path="/adddrivers-transport" element={<AddDriverTransport />} />
            <Route path="/drivers-triphistory" element={<DriverTripHistory />} />

            <Route path="/booking-management" element={<BookingManagement />} />
            <Route path="/booking-request" element={<BookingRequest />} />
            <Route path="/booking-assign" element={<BookingAssign />} />

            <Route path="/user-transactions" element={<UserTransactions />} />
            <Route path="/transport-transaction" element={<Transaction />} />
            <Route path="/transaction-view" element={<TransactionView />} />


            <Route path="/push-notification" element={<PushNotification />} />
            <Route path="/addpush-notification" element={<PushNotificationAdd />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/faq-edit" element={<FAQEdit />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/add-contact" element={<AddContact />} />
            <Route path="/help-support" element={<HelpSupport />} />
            <Route path="/help-view" element={<Helpview />} />
          </Route>
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
};

export default RctRoutes;
